<template>
  <a :href="href" @click="onClick">
    <slot></slot>
  </a>
</template>

<script>
import { getRouteByName } from "@/landing/router/routes";
export default {
  props: {
    to: {
      type: Object,
      default: () => {
        "welcome";
      },
    },
  },
  computed: {
    isOnRoute() {
      return this.$router.name !== this.to.name;
    },

    toRoute() {
      return getRouteByName(this.$router.name);
    },

    href() {
      if (this.isOnRoute) return "/#home";
      return this.toRoute.path;
    },
  },
  methods: {
    onClick(evt) {
      if (!this.isOnRoute) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>

<style></style>
